import { SThemeThemes } from 'servisofts-component';

const theme: SThemeThemes = {
    default: {
        barStyle: 'dark-content',
        barColor: '#ffffff',
        text: '#000000',
        primary: '#ffffff',
        secondary: '#000000',
        info: '#97989d',
        background: '#ffffff',
        // card: '#00000010',
        card: '#00000015',
        font: "Roboto"
    },
    dark: {
        barStyle: 'light-content',
        barColor: '#000000',
        text: '#ffffff',
        primary: '#000000',
        secondary: '#ffffff',
        info: '#6E6F74',
        background: '#000000',
        card: '#ffffff15',
        font: "Roboto"
        // card: '#ffffff10'
    }
}
export default theme;